module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/instagram/suns_sns_03-90dbd106cb2af42abf3d4acd4f13e180.jpg";